"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var native_1 = __importDefault(require("styled-components/native"));
var react_native_1 = require("react-native");
var ATLAtomLine_1 = require("../atoms/ATLAtomLine");
var ThemeProvider_1 = require("../theme/ThemeProvider");
// --------------------------------------------- MOLECULE ATLDivider -----------------------------------------------
// A line with the function to section lists.
// [DOC - Design]: https://atlantica-docs.outsmartyourself.com.br/docs/moleculeListDivider/
// [DOC - Dev]: https://atlantica-docs.outsmartyourself.com.br/docs/devMoleculeListDivider/
// Enum with Divider Types
var DividerTypesEnum;
(function (DividerTypesEnum) {
    DividerTypesEnum[DividerTypesEnum["regular"] = 0] = "regular";
    DividerTypesEnum[DividerTypesEnum["noSpacing"] = 1] = "noSpacing";
    DividerTypesEnum[DividerTypesEnum["leftSpacing"] = 2] = "leftSpacing";
})(DividerTypesEnum = exports.DividerTypesEnum || (exports.DividerTypesEnum = {}));
var defaultProps = {
    complementary: false,
    type: DividerTypesEnum.regular,
    dividerBaseProps: {}
};
// STYLED COMPONENTS ---------------------------------------------------------------------------------------------------
exports.ContainerRegular = native_1.default(react_native_1.View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 0\n  ", "px 0 \n  ", "px;\n"], ["\n  padding: 0\n  ", "px 0 \n  ", "px;\n"])), function (_a) {
    var atlTheme = _a.theme, props = __rest(_a, ["theme"]);
    return props.rightMargin || atlTheme.SpacingMarginal;
}, function (_a) {
    var atlTheme = _a.theme, props = __rest(_a, ["theme"]);
    return props.leftMargin || atlTheme.SpacingMarginal;
});
exports.ContainerLeftSpacing = native_1.default(react_native_1.View)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 0 0 0 ", "px;\n"], ["\n  padding: 0 0 0 ", "px;\n"
    // COMPONENT -----------------------------------------------------------------------------------------------------------
])), function (_a) {
    var atlTheme = _a.theme, props = __rest(_a, ["theme"]);
    return props.leftMargin || atlTheme.SpacingWide;
});
// COMPONENT -----------------------------------------------------------------------------------------------------------
exports.ATLDivider = function (_a) {
    var complementary = _a.complementary, type = _a.type, leftMargin = _a.leftMargin, rightMargin = _a.rightMargin, dividerBaseProps = _a.dividerBaseProps;
    var theme = ThemeProvider_1.useTheme();
    // Renders the line itself
    var renderLine = (react_1.default.createElement(ATLAtomLine_1.ATLAtomLine, __assign({ thickness: theme.HeightDivider, color: complementary ? theme.ColorComplementary1 : theme.ColorMediumContrast }, dividerBaseProps)));
    // Renders the different types of dividers
    var renderListDivider = function () {
        switch (type) {
            case DividerTypesEnum.noSpacing:
                return (renderLine);
            case DividerTypesEnum.leftSpacing:
                return (react_1.default.createElement(exports.ContainerLeftSpacing, { leftMargin: leftMargin }, renderLine));
            case DividerTypesEnum.regular:
                return (react_1.default.createElement(exports.ContainerRegular, { leftMargin: leftMargin, rightMargin: rightMargin }, renderLine));
            default:
                return (react_1.default.createElement(exports.ContainerRegular, { leftMargin: leftMargin, rightMargin: rightMargin }, renderLine));
        }
    };
    // Returns complete ATLDivider
    return renderListDivider();
};
exports.ATLDivider.defaultProps = defaultProps;
exports.ATLDivider.displayName = 'ATLDivider';
var templateObject_1, templateObject_2;
